import { render, staticRenderFns } from "./CostCenter.vue?vue&type=template&id=0b958b0e"
import script from "./CostCenter.vue?vue&type=script&lang=js"
export * from "./CostCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports